const state = {
  isWelcomeShowed: null,
  isDeviceLaunchTourShowed: null,
  isWelcomeVisible: true,
  welcomeContent: {
    title: "Welcome Aboard!",
    text: "Embark on our product tour to discover how M-Connect streamlines processes and boosts success for you and other teams. Experience unparalleled compatibility, collaboration, and efficiency with our all-in-one solution. Enjoy the tour!",
    url: require("@/assets/images/welcome.png"),
  },
};
const getters = {
  getShowWelcome(state, getters) {
    return (
      getters.isTrialUser && !state.isWelcomeShowed && state.isWelcomeVisible
    );
  },
  getShowLaunchDeviceTour(state, getters) {
    return (
      getters.isTrialUser &&
      !state.isDeviceLaunchTourShowed &&
      state.isWelcomeVisible
    );
  },
  getWelcomeContent(state) {
    return state.welcomeContent;
  },
};
const mutations = {
  setIsWelcomeVisible(state, value) {
    state.isWelcomeVisible = value;
  },
  setIsWelcomeShowed(state, value) {
    localStorage.setItem("is_welcome_showed", value);
    state.isWelcomeShowed = value;
  },
  setIsDeviceLaunchTourShowed(state, value) {
    localStorage.setItem("is_device_launch_tour_showed", value);
    state.isDeviceLaunchTourShowed = value;
  },
};
const actions = {
  emitIsWelcomeShowed({ commit }, value) {
    commit("setIsWelcomeShowed", value);
  },
  emitIsDeviceLaunchTourShowed({ commit }, value) {
    commit("setIsDeviceLaunchTourShowed", value);
  },
  emitShowTourInfo({ commit }) {
    const isWelcomeShowed =
      localStorage?.getItem("is_welcome_showed") !== "false";
    const isDeviceLaunchTourShowed =
      localStorage?.getItem("is_device_launch_tour_showed") !== "false";
    commit("setIsWelcomeShowed", isWelcomeShowed);
    commit("setIsDeviceLaunchTourShowed", isDeviceLaunchTourShowed);
  },
};
export default {
  state,
  getters,
  mutations,
  actions,
};
